import React from 'react';
import { BUILDER_ID } from '../data/builder';
const items = ["★ America's 250th", 'Build your X1 from $29.95', 'Free U.S. shipping', 'Lifetime replacement on multi-packs'];

/**
 * Slim, permanent value line above the header. No countdown, no crossed-out
 * prices: one row on desktop, a slow ticker on phones where it can't fit.
 */
export function AnnouncementBar() {
  return <a href={`#${BUILDER_ID}`} aria-label="America's 250th. Build your X1 from $29.95. Free U.S. shipping. Lifetime replacement on multi-packs." className="block w-full overflow-hidden bg-grit-500 text-ink-950 transition-colors duration-150 ease-grit hover:bg-grit-400 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ink-950" data-id="element-23" data-mp="9wfe34v12czk">
      {/* Desktop and tablet: one centered line */}
      <p className="hidden items-center justify-center gap-3 px-4 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.16em] md:flex" data-id="element-24" data-mp="1v8ql4iss9z1c">
        {items.map((item, i) => <React.Fragment key={item} data-id="element-25" data-mp="680cmwie5m94" data-mpi={i}>
            {i > 0 && <span aria-hidden="true" data-id="element-26" data-mp="6acvrczvy2nr">•</span>}
            <span className="whitespace-nowrap" data-id="element-27" data-mp="aa3r7u0cx6ym">{item}</span>
          </React.Fragment>)}
      </p>

      {/* Phones: compact ticker */}
      <div aria-hidden="true" className="grit-marquee md:hidden" data-id="element-28" data-mp="3shb62dawlc78">
        <div className="grit-ticker flex w-max items-center py-1.5 text-[10px] font-extrabold uppercase tracking-[0.16em]" data-id="element-29" data-mp="1a8azary2lrq">
          {[0, 1].map(copy => <span key={copy} className="flex items-center" data-id="element-30" data-mp="txunj8j5h0qq">
              {items.map(item => <span key={item} className="flex items-center whitespace-nowrap" data-id="element-31" data-mp="f980slr716ph">
                  <span className="px-3" data-id="element-32" data-mp="f73xo614cbq9">{item}</span>
                  <span data-id="element-33" data-mp="k6zu9k7hl0vs">•</span>
                </span>)}
            </span>)}
        </div>
      </div>
    </a>;
}